import React, { useEffect, useRef, useState } from "react";
import { useDebounce } from "use-debounce";
import { useSearchCustomerQuery } from "../store/moves/apis";
import { Input } from "./ui/input"; // Adjust import path as needed
import { Customer } from "@/types";

const CustomerSearch: React.FC<{
  placeholder: string;
  onSelectCustomer: (customer: Customer) => void;
}> = ({ placeholder, onSelectCustomer }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 300);
  const [isResultsOpen, setIsResultsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const { data: customers, isLoading } = useSearchCustomerQuery(
    debouncedSearchTerm,
    {
      skip: debouncedSearchTerm.length < 3,
    }
  );

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsResultsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsResultsOpen(
      debouncedSearchTerm.length >= 3 && !isLoading && !!customers
    );
  }, [debouncedSearchTerm, isLoading, customers]);

  // const handleSelectCustomer = (customer: Customer) => {
  //   onSelectCustomer(customer);
  //   setIsResultsOpen(false);
  //   setSearchTerm("");
  // };

  return (
    <div className="relative" ref={wrapperRef}>
      <Input
        type="search"
        placeholder={placeholder}
        className="flex-grow w-full"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {isResultsOpen && (
        <ul className="absolute z-20 w-full mt-0.5 shadow-lg h-60 bg-white border-l border-r border-b border-black">
          {customers.map((customer: Customer) => (
            <li
              key={customer.id}
              className="px-4 py-3 hover:bg-stone-50 cursor-pointer"
              onClick={() => onSelectCustomer(customer)}
            >
              <div className="font-semibold">{customer.name}</div>
              <div className="text-sm text-gray-800">
                {customer.mobile_phone} | {customer.alternate_phone} |{" "}
                {customer.email}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomerSearch;
